import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import VenueDetailLayer from "../components/VenueDetailLayer";
import { useParams } from "react-router-dom";

const VenueDetailPage = () => {
    const { id } = useParams();
    
    return (
        <MasterLayout>
            <Breadcrumb title="Venue Details" />
            <VenueDetailLayer venueId={id} />
        </MasterLayout>
    );
};

export default VenueDetailPage;
